(function () {
  // Only run on product pages
  if (!document.querySelector('[data-section-type="product"]')) return;

  const stickyBar = document.querySelector('[data-sticky-bar]');
  if (!stickyBar) return;

  const sizeBtn = document.getElementById('stickySizeBtn');
  const sizeDropdown = document.getElementById('stickySizeDropdown');
  const sizeText = document.querySelector('[data-sticky-size-text]');
  const stickyPrice = document.querySelector('[data-sticky-price]');
  const stickyAddToCart = document.querySelector('[data-sticky-add-to-cart]');
  const stickyButtonText = document.querySelector('[data-sticky-button-text]');
  const mainAddToCart = document.querySelector('[data-add-to-cart]');
  const mainForm = document.querySelector('.product-single__form');

  // Get buy button for visibility check
  const buyButtonsBlock = document.querySelector('.product-block [data-add-to-cart]');

  // Show/hide sticky bar based on buy buttons visibility
  function checkStickyBarVisibility() {
    if (!buyButtonsBlock) {
      stickyBar.classList.add('is-visible');
      return;
    }

    const rect = buyButtonsBlock.getBoundingClientRect();
    const isOutOfView = rect.bottom < 0;

    stickyBar.classList.toggle('is-visible', isOutOfView);
  }

  // Listen for scroll events with performance optimization
  let scrollTicking = false;
  window.addEventListener('scroll', function () {
    if (!scrollTicking) {
      window.requestAnimationFrame(function () {
        checkStickyBarVisibility();
        scrollTicking = false;
      });
      scrollTicking = true;
    }
  }, { passive: true });

  // Initial check
  checkStickyBarVisibility();

  // Function to update sticky button state
  function updateStickyButtonState(isAvailable) {
    if (stickyAddToCart && stickyButtonText) {
      if (isAvailable) {
        stickyAddToCart.disabled = false;
        stickyAddToCart.classList.remove('product-sticky-bar__button--disabled');
        stickyButtonText.textContent = 'Add To Cart';
      } else {
        stickyAddToCart.disabled = true;
        stickyAddToCart.classList.add('product-sticky-bar__button--disabled');
        stickyButtonText.textContent = theme.strings.soldOut || 'Out of Stock';
      }
    }
  }

  // Initialize button state on page load based on currently selected variant
  function initializeButtonState() {
    if (sizeText && sizeDropdown) {
      const currentSize = sizeText.textContent.trim();
      const sizeOptions = sizeDropdown.querySelectorAll('.sticky-size-option');

      sizeOptions.forEach(function (option) {
        if (option.getAttribute('data-size-value') === currentSize) {
          const isAvailable = option.getAttribute('data-available') === 'true';
          updateStickyButtonState(isAvailable);
        }
      });
    }
  }

  // Call initialization
  initializeButtonState();

  // Size dropdown toggle
  if (sizeBtn && sizeDropdown) {
    sizeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      const isExpanded = sizeBtn.getAttribute('aria-expanded') === 'true';
      sizeBtn.setAttribute('aria-expanded', !isExpanded);
      sizeDropdown.classList.toggle('active');
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function (e) {
      if (!stickyBar.contains(e.target)) {
        sizeBtn.setAttribute('aria-expanded', 'false');
        sizeDropdown.classList.remove('active');
      }
    });

    // Size selection in sticky bar
    const sizeOptions = sizeDropdown ? sizeDropdown.querySelectorAll('.sticky-size-option') : null;
    if (sizeOptions) {
      sizeOptions.forEach(function (option) {
        option.addEventListener('click', function () {
          const sizeValue = this.getAttribute('data-size-value');
          const isAvailable = this.getAttribute('data-available') === 'true';

          // Update sticky bar size text
          if (sizeText) {
            sizeText.textContent = sizeValue;
          }

          // Update active state in sticky dropdown
          sizeOptions.forEach(opt => opt.classList.remove('active'));
          this.classList.add('active');

          // Update button state based on availability
          updateStickyButtonState(isAvailable);

          // Update main form variant
          const mainSizeInputs = document.querySelectorAll('[data-variant-input]');
          mainSizeInputs.forEach(function (input) {
            const optionName = input.name.toLowerCase();
            const inputType = input.type;
            if ((inputType === 'radio' || inputType === 'checkbox') && optionName.includes('size') && input.value === sizeValue) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });

          // Close dropdown
          sizeBtn.setAttribute('aria-expanded', 'false');
          sizeDropdown.classList.remove('active');
        });
      });
    }
  }

  // Sync main variant selection to sticky bar
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-variant-input]')) {
      // IMPORTANT: Ignore inputs from grid product ATC modals
      // Only sync inputs from the main product section
      if (e.target.closest('.atc-modal')) {
        return; // This is from a grid product modal, not the main product
      }

      const optionName = e.target.name.toLowerCase();
      const inputType = e.target.type;
      if ((inputType === 'radio' || inputType === 'checkbox') && optionName.includes('size') && e.target.checked) {
        const sizeValue = e.target.value;
        const isDisabled = e.target.classList.contains('disabled');

        // Update sticky size text
        if (sizeText) {
          sizeText.textContent = sizeValue;
        }

        // Update button state based on availability
        updateStickyButtonState(!isDisabled);

        // Update active state in sticky dropdown
        const sizeOptions = sizeDropdown ? sizeDropdown.querySelectorAll('.sticky-size-option') : null;
        if (sizeOptions) {
          sizeOptions.forEach(function (option) {
            option.classList.remove('active');
            if (option.getAttribute('data-size-value') === sizeValue) {
              option.classList.add('active');
            }
          });
        }
      }
    }
  });

  // Sync with main product form variant changes
  document.addEventListener('variantChange', function (evt) {
    const variant = evt.detail.variant;

    if (variant) {
      // Update price
      if (stickyPrice) {
        stickyPrice.textContent = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat).replace('₹', 'Rs.');
      }

      // Update size text
      if (sizeText && variant.option1) {
        sizeText.textContent = variant.option1;
      }

      // Update add to cart button state
      updateStickyButtonState(variant.available);

      // Update active size in dropdown
      const sizeOptions = sizeDropdown ? sizeDropdown.querySelectorAll('.sticky-size-option') : null;
      if (sizeOptions) {
        sizeOptions.forEach(function (option) {
          option.classList.remove('active');
          if (option.getAttribute('data-size-value') === variant.option1) {
            option.classList.add('active');
          }
        });
      }
    }
  });

  // Sticky add to cart functionality
  if (stickyAddToCart && mainAddToCart) {
    stickyAddToCart.addEventListener('click', function (e) {
      e.preventDefault();

      // Trigger the main add to cart button
      mainAddToCart.click();
    });
  }
})();